var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",attrs:{"id":"nc-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }